/**
 * Locale de PrimeVue en español (es).
 *
 * Mantenerlo en su propio módulo evita duplicar un objeto de ~100 líneas dentro
 * de `main.ts` y permite reutilizarlo en los tests que montan PrimeVue.
 */
export const esLocale = {
  accept: 'Acepta',
  addRule: 'Añadir regla',
  am: 'AM',
  apply: 'Aplicar',
  cancel: 'Cancelar',
  choose: 'Elegir',
  clear: 'Limpiar',
  contains: 'Contiene',
  dateAfter: 'Fecha posterior',
  dateBefore: 'Fecha anterior',
  dateFormat: 'dd/mm/yy',
  dateIs: 'Es',
  dateIsNot: 'No es',
  dayNames: [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ] as const,
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'] as const,
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'] as const,
  emptyFilterMessage: 'Sin resultados',
  emptyMessage: 'No hay opciones disponibles',
  emptySearchMessage: 'Sin resultados de búsqueda',
  emptySelectionMessage: 'Ningún elemento seleccionado',
  endsWith: 'Termina con',
  equals: 'Es igual a',
  filter: 'Filtrar',
  firstDayOfWeek: 1,
  gt: 'Mayor que',
  gte: 'Mayor o igual que',
  lt: 'Menor que',
  lte: 'Menor o igual que',
  matchAll: 'Coincidir todo',
  matchAny: 'Coincidir cualquiera',
  medium: 'Medio',
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ] as const,
  monthNamesShort: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ] as const,
  next: 'Siguiente',
  nextDecade: 'Próxima década',
  nextMonth: 'Próximo mes',
  nextYear: 'Próximo año',
  no: 'No',
  noFilter: 'Sin filtro',
  noResult: 'Sin resultados',
  notContains: 'No contiene',
  notEquals: 'No es igual a',
  passwordPrompt: 'Introduzca una contraseña',
  pending: 'Pendiente',
  pm: 'PM',
  previous: 'Anterior',
  previousDecade: 'Década anterior',
  previousMonth: 'Mes anterior',
  previousYear: 'Año anterior',
  prompt: 'Elige una opción',
  reject: 'Rechazar',
  removeRule: 'Eliminar regla',
  search: 'Buscar',
  searchMessage: '{0} resultados disponibles',
  selectAll: 'Seleccionar todo',
  selectionMessage: '{0} elementos seleccionados',
  select: 'Seleccionar',
  showPassword: 'Mostrar contraseña',
  hidePassword: 'Ocultar contraseña',
  strong: 'Fuerte',
  today: 'Hoy',
  upload: 'Subir',
  weak: 'Débil',
  weekHeader: 'Sem',
  yearSuffix: '',
} as const